export default "__VITE_ASSET__DAODjIu5__"